import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import googleAuthenticatorIcon from "@/icons/apps/google-authenticator.png";
import microsoftAuthenticatorIcon from "@/icons/apps/microsoft-authenticator.png";
import authyIcon from "@/icons/apps/authy.png";

/** App Store icons of the authenticator apps people use most */
const APPS = [
  { name: "Google Authenticator", icon: googleAuthenticatorIcon },
  { name: "Microsoft Authenticator", icon: microsoftAuthenticatorIcon },
  { name: "Authy", icon: authyIcon },
];

/** Small "i" next to the step; hover or focus it to see which apps work */
export function AuthenticatorAppsHint() {
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label="Which authenticator apps work"
            className="inline-flex size-5 translate-y-[3px] items-center justify-center rounded-full text-muted-foreground hover:text-primary focus-visible:text-primary focus-visible:outline-2 focus-visible:outline-primary"
          >
            <Info className="size-3.5" />
          </button>
        </TooltipTrigger>
        <TooltipContent side="top" sideOffset={6} className="px-3 py-2.5">
          <p className="mb-2 text-[11px] font-medium opacity-70">Works with any authenticator app, like</p>
          <ul className="flex gap-4">
            {APPS.map(({ name, icon }) => (
              <li key={name} className="flex w-[72px] flex-col items-center gap-1.5 text-center text-[11px] leading-tight">
                <img src={icon} alt="" className="size-9 rounded-[9px]" />
                {name}
              </li>
            ))}
          </ul>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
